module.exports = __webpack_public_path__ + "ffc205d16c7b66fe2a13cb28c432f668.jpg";